import { GetTargetingParametersForProviderResponse } from '@provider-portal/common/api/types';
import { ActionType, createAsyncAction } from 'typesafe-actions';

export const requestTargetingParametersAsyncAction = createAsyncAction(
  '@targetingParameters/GET_TARGETING_PARAMETERS_REQUEST',
  '@targetingParameters/GET_TARGETING_PARAMETERS_SUCCESS',
  '@targetingParameters/GET_TARGETING_PARAMETERS_FAILURE',
)<void, GetTargetingParametersForProviderResponse, Error>();

export type TargetingParametersActions = ActionType<typeof requestTargetingParametersAsyncAction>;
